type Param = {
  key: string,
  value: string
}

function interpolateTemplate(template: string, params: Param[]): string {
  let interpolatedHtml = template;

  params.forEach(({ key, value }) => {
    interpolatedHtml = interpolatedHtml.split(`{{${key}}}`).join(value ?? '');
  });

  return interpolatedHtml.trim();
}

export function getHTMLElement(template: string, params: Param[]): DocumentFragment {
  const templateEl = document.createElement('template');
  templateEl.innerHTML = interpolateTemplate(template, params);

  return templateEl.content;
}

// Returns the interpolated template as an HTML string — use this when the result
// is embedded in another string (e.g. template-literal concatenation) rather than
// inserted into the DOM directly. getHTMLElement returns a DocumentFragment, which
// stringifies to "[object DocumentFragment]" in a template literal.
export function getHTMLString(template: string, params: Param[]): string {
  return interpolateTemplate(template, params);
}